module.exports = __webpack_public_path__ + "img/informe-de-detalle-de-referidos.2c19b82f.svg";